import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { SHOW_VIDEO_COUNT } from "app-constants/constants"
import AspectRatio from "components/common/AspectRatio"
import Link, { LinkProps } from "next/link"
import pluralize from "pluralize"
import React from "react"

interface SmallVideoCardProps {
  href: LinkProps["href"]
  imageSrc: string
  imageAlt: string
  curatorName: string
  title: string
  numberOfViews: number
  width?: string
}

const useStyles = makeStyles()(
  (theme) => ({
    card: {
      display: "flex",
      minWidth: 250,
      width: "100%",
      maxWidth: 500,
      minHeight: 270,
      borderRadius: 10,
      marginBottom: 2, // it's needed to show card bottom box-shadow
    },
    cardActionArea: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    mediaCardImageContainer: {
      width: "100%",
    },
    cardContent: {
      padding: theme.spacing(1),
      paddingTop: 0,
    },
    curatorName: {
      marginTop: 10,
      ...theme.fonts.lato400,
      fontSize: 14,
      wordBreak: "break-word",
      lineHeight: 1.2,
    },
    title: {
      ...theme.fonts.raleway600,
      fontSize: 24,
      wordBreak: "break-word",
    },
    numberOfViews: {
      ...theme.fonts.lato400,
      fontSize: 14,
    },
  }),
)

const SmallVideoCard = (props: SmallVideoCardProps) => {
  const { imageSrc, href, curatorName, title, numberOfViews, imageAlt } = props
  const { classes } = useStyles()
  return (
    <Link href={href} passHref legacyBehavior>
      <Card className={classes.card}>
        <CardActionArea className={classes.cardActionArea}>
          <AspectRatio ratio={25 / 12} className={classes.mediaCardImageContainer}>
            <CardMedia
              component="img"
              image={imageSrc}
              alt={imageAlt}
              aria-hidden={imageAlt.length === 0}
            />
          </AspectRatio>
          <CardContent className={classes.cardContent}>
            <Typography
              gutterBottom
              variant="overline"
              component="p"
              className={classes.curatorName}>
              {curatorName}
            </Typography>
            <Typography gutterBottom variant="h2" className={classes.title}>
              {title}
            </Typography>
            {SHOW_VIDEO_COUNT && (
              <Typography gutterBottom variant="body2" className={classes.numberOfViews}>
                {pluralize(`${numberOfViews.toLocaleString()} views`)}
              </Typography>
            )}
          </CardContent>
        </CardActionArea>
      </Card>
    </Link>
  )
}

export default SmallVideoCard
